export default {
    methods: {
        getArrayPositionByItemId(array, id){
            //Devuelve la posición en el array indicado del id que se le pasa
            return array.findIndex(x => x.id === id);
        }
    }
}